<ng-container *ngFor="let option of hintDialogOptions; index as i">
  <sigv-content-dialog
    [visible]="true"
    dialogSize="small"
    [showConfirm]="
      option.hintType === 'confirm' || option.hintType === 'onlyConfirm'
    "
    [showCancel]="option.hintType != 'onlyConfirm'"
    [confirmText]="option.confirmText"
    [cancelText]="option.cancelText"
    [baseZIndex]="10000"
    (cancel)="onDialogCancel(i, $event)"
    (confirm)="onDialogConfirm(i, $event)"
  >
    <ng-template pTemplate="header">
      <div class="p-d-flex p-dialog-title p-ai-center">
        <i
          *ngIf="option.headerIcon"
          class="p-mr-2"
          [ngClass]="option.headerIcon"
        ></i>
        {{ (option.header ? option.header : '') | translate }}
      </div>
    </ng-template>
    <div class="p-grid">
      <ng-container *ngIf="option.hintType === 'list'; else msgContent">
        <div class="p-col-12" *ngIf="option.message">
          {{
            (option.message.category ? option.message.category : '') | translate
          }}
        </div>
        <div class="p-col-12">
          <div
            *ngFor="let msg of option.messages"
            [ngClass]="
              msgDisplay(msg.message)
                ? 'dialog-format-error dialog-list-item'
                : ''
            "
          >
            <ng-container *ngIf="msgDisplay(msg.message)">
              <div class="dialog-list-item-left">
                <label class="text">{{
                  (msg.category ? msg.category : '') | translate
                }}</label>
              </div>
              <div class="dialog-list-item-right">
                <p class="desc p-m-0" [class.p-error]="!msg.success">
                  {{ (msg.message ? msgProcess(msg.message) : '') | translate
                  }}{{ msg.message ? msgProcess(msg.message, true) : '' }}
                </p>
              </div>
            </ng-container>
          </div>
        </div>
      </ng-container>
      <ng-template #msgContent>
        <ng-container *ngIf="option.message">
          <div
            class="p-col-12"
            *ngIf="option.message.category"
            style="white-space: pre-line"
          >
            {{
              (option.message.category ? option.message.category : '')
                | translate
            }}
          </div>
          <div class="p-col-12" *ngIf="option.message.message">
            <p-accordion
              [multiple]="true"
              expandIcon="pi pi-fw pi-collapse-open"
              collapseIcon="pi pi-fw pi-collapse-close"
            >
              <p-accordionTab header="Error Description" [selected]="false">
                {{ option.message.message }}
              </p-accordionTab>
            </p-accordion>
          </div>
        </ng-container>
      </ng-template>
    </div>
  </sigv-content-dialog>
</ng-container>
